// Central place for site copy so text changes don't require touching layout code.
import NDPLogo from "../components/assets/NDPLogo.png";
import JoyholidayLogo from "../components/assets/JoyholidayLogo.png";
import PDPDataLogo from "../components/assets/PDPDataLogo.svg";
import Kantalogo from "../components/assets/Kantalogo.png";
import StrategicexecutionconsultantsLogo from "../components/assets/StrategicexecutionconsultantsLogo.png";

export const company = {
  name: "MN2GROW",
  tagline: "Tech and AI driven data",
  email: "info@mn2grow.com",
  officePhone: { label: "020-237-231", href: "tel:020237231" },
  thaiSupport: { label: "+66 635-156-696", href: "tel:+66635156696" },
  englishSupport: { label: "+66 822-374-155", href: "tel:+66822374155" },
  address: [
    "515/226 Moo 3, Takhukot",
    "Lam Luk Ka District",
    "Pathum Thani 12130",
    "Bangkok Metropolitan Area, Thailand",
  ],
};

export const navLinks = [
  {
    href: "#services",
    label: "Services",
    children: [
      { href: "#services", label: "All Services", desc: "Everything we offer" },
      {
        href: "https://pdpapishopee-production.up.railway.app/",
        label: "ProductIQ",
        desc: "Product page data API",
        external: true,
      },
      {
        href: "https://www.mn2grow.com/ClubHouseIntelligence.mp4",
        label: "ClubHouse Intelligence",
        desc: "Member & club operations insights",
        external: true,
      },
    ],
  },
  { href: "#approach", label: "Approach" },
  { href: "#about", label: "Company" },
  { href: "#clients", label: "Clients" },
  { href: "#contact", label: "Contact" },
];

export const stats = [
  { value: "10+", label: "Projects delivered" },
  { value: "5+", label: "Enterprise clients" },
  { value: "13", label: "Service lines" },
  { value: "TH / EN", label: "Bilingual support" },
];

export const practices = [
  {
    id: "data",
    code: "01",
    title: "Data Services",
    summary:
      "We collect, engineer and govern the data your business runs on — then turn it into reporting and intelligence your teams can act on.",
    services: [
      {
        icon: "fa-database",
        title: "Data Engineering",
        text: "Robust pipelines, ETL processes and data platforms that keep enterprise data accurate and available.",
      },
      {
        icon: "fa-magnifying-glass-chart",
        title: "PDP Data Solutions",
        text: "Product detail page extraction, crawling, cleaning, validation, monitoring and API-based delivery.",
      },
      {
        icon: "fa-spider",
        title: "Web & Data Scraping",
        text: "Structured and unstructured data collected from multiple sources for research, monitoring and integration.",
      },
      {
        icon: "fa-chart-pie",
        title: "BI & Dashboards",
        text: "Interactive real-time dashboards for KPIs, operations, sales, finance and performance.",
      },
      {
        icon: "fa-brain",
        title: "AI Analytics",
        text: "Predictive models and advanced insights powered by machine learning.",
      },
      {
        icon: "fa-robot",
        title: "AI & Automation",
        text: "Intelligent automation that removes manual steps from business operations.",
      },
    ],
  },
  {
    id: "apps",
    code: "02",
    title: "Web & Application Development",
    summary:
      "We design and build the websites, applications and business systems that put your data to work — secure, scalable and built around your processes.",
    services: [
      {
        icon: "fa-globe",
        title: "Website Development",
        text: "Modern, responsive and high-performance websites for businesses, startups and enterprises.",
      },
      {
        icon: "fa-mobile-screen-button",
        title: "Web & Mobile Apps",
        text: "Custom web and cross-platform mobile applications that streamline workflows.",
      },
      {
        icon: "fa-code",
        title: "Custom Software",
        text: "Tailor-made software designed around your unique business processes and requirements.",
      },
      {
        icon: "fa-building",
        title: "ERP Solutions",
        text: "Finance, inventory, sales, procurement, operations and HR managed in one system.",
      },
      {
        icon: "fa-users-gear",
        title: "CRM Solutions",
        text: "Lead, sales, customer service and communication management for business growth.",
      },
      {
        icon: "fa-cloud",
        title: "Cloud Solutions",
        text: "Secure, scalable cloud infrastructure, migration and cloud-native architecture.",
      },
    ],
  },
];

export const approach = [
  {
    step: "01",
    title: "Discover",
    text: "We map your goals, data sources, systems and constraints, and agree on measurable outcomes.",
  },
  {
    step: "02",
    title: "Design",
    text: "Solution architecture, data models and user experience are designed and reviewed with your team.",
  },
  {
    step: "03",
    title: "Build",
    text: "Agile delivery in short iterations, with working software and validated data at every milestone.",
  },
  {
    step: "04",
    title: "Operate",
    text: "Deployment, monitoring, data quality checks and ongoing support as your business scales.",
  },
];

export const pillars = [
  {
    icon: "fa-shield-halved",
    title: "Secure by design",
    text: "Access control, validated data flows and secure cloud infrastructure from day one.",
  },
  {
    icon: "fa-layer-group",
    title: "One partner, full stack",
    text: "Data collection, engineering, analytics and applications delivered by a single team.",
  },
  {
    icon: "fa-language",
    title: "Thai & English support",
    text: "Dedicated support lines in both languages for local and international clients.",
  },
  {
    icon: "fa-arrows-rotate",
    title: "Built to scale",
    text: "Architecture that grows with your data volumes, users and business requirements.",
  },
];

export const clients = [
  {
    name: "New Democratic Party",
    logo: NDPLogo,
    category: "Web & Apps",
    project: "Web & mobile app development",
  },
  {
    name: "Joy Holiday",
    logo: JoyholidayLogo,
    category: "Cloud",
    project: "Cloud integration solution",
  },
  {
    name: "PDP Data",
    logo: PDPDataLogo,
    category: "Data Services",
    project:
      "Transforming product information from complex e-commerce platforms into structured, accurate and actionable product data.",
  },
  {
    name: "KANTA SERVICE Co., Ltd.",
    logo: Kantalogo,
    category: "AI & Technology",
    project:
      "Technology partner to an organization specializing in military solutions, agriculture and Artificial Intelligence.",
  },
  {
    name: "Strategic Execution Consultants",
    logo: StrategicexecutionconsultantsLogo,
    category: "Data Services",
    project: "Data analytics & reporting platform",
  },
];

export const serviceOptions = [
  "Data engineering / pipelines",
  "PDP data / web scraping",
  "BI & dashboards",
  "AI analytics & automation",
  "Website development",
  "Web or mobile application",
  "ERP / CRM / custom software",
  "Cloud solutions",
  "Other",
];
